import $ from 'jquery';
import { View } from 'backbone';

import template from 'designer/asset.ejs';
import constants from 'Constants.js';
//=====================================================================
//
// An instance of this view represents an Asset Instance.
//
// Brad Trebilcock, April 4, 2016
//
//=====================================================================
class AssetView extends View  {

    initialize( opts ) {
        super.initialize( opts );
        this.template = template;
        this.tagName = 'div';
        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    get kind() {
        return '';
    }

    render() {
        let name = this.model.get('name');
        let lastIndex = name.lastIndexOf(".");

        if (lastIndex > 0){
            this.model.set('tmpName', name.substr(0, lastIndex), {silent: true});
        }else{
            this.model.set('tmpName', name, {silent: true});
        }
        
        this.model.set('ext', name.substr(lastIndex), {silent: true});

        this.model.set('controlType', this.resolveAssetControlType(), { silent: true });

        let itemDivs = $('#assets .carousel-inner .item');
        let element =  itemDivs.first();
       
        let lastElement = element;
        for (let x = 0; x < itemDivs.length; x++){
            if (element[0].children.length < constants.MAX_ITEMS_PER_SECTION_TOOLBAR){
                lastElement = element;
                break;
            }

            element = element.next();
        }

        let itemCount = lastElement[0].children.length; 
        if (itemCount < constants.MAX_ITEMS_PER_SECTION_TOOLBAR){
             lastElement.append(this.template(this.model.toJSON()));
        } 
        else {
            let  _template = `<div class="item">
                                <div class="col-sm-1 nopadding factory-widget toolbar-button-container asset_new" draggable="false">
                                    <div class="thumb ui-widget-header toolbar-button">
                                        <p class="assets-top">Add<br>Image</p>
                                    </div>
                                </div>

                                <div class="col-sm-1 nopadding factory-widget toolbar-button-container asset_delete" draggable="false" style="
                                margin-left: 5px !important;
                                margin-right: 10px !important;">
                                    <div class="thumb ui-widget-header toolbar-button">
                                        <p class="assets-top">Delete Image</p>
                                    </div>
                                </div> 
                            </div>`;
            $('#assets .carousel-inner').append(_template);
            lastElement =  $('#assets .carousel-inner .item').last();
            lastElement.append(this.template( this.model.toJSON() ));
        }        

        $('#assets [data-toggle="tooltip"]').tooltip({
            'delay': { show: 300, hide: 300 }
        });

        this.delegateEvents();
        return this;
    }

    resolveAssetControlType(){
        let controlTypeAsId;
        const mimeType = this.model.get('mimeType');    
        if (mimeType.indexOf('image') !== -1){
            controlTypeAsId = 'control_picture';
        }else if (mimeType.indexOf('video') !== -1){
            controlTypeAsId = 'control_movie';
        }else if (mimeType.indexOf('audio') !== -1){
            controlTypeAsId = 'control_sound';
        }

        return controlTypeAsId;
    }

}

export default AssetView;
